(() => {
  if (customElements.get("announcement-slider")) {
    return;
  }

  class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const disabledMobile = this.hasAttribute("disabled-mobile");
      const disabledDesktop = this.hasAttribute("disabled-desktop");

      const swiper = new Swiper(this, {
        direction: "horizontal",
        enabled: !disabledMobile || true,
        autoplay: { 
          delay: Number(this.dataset.autoplayInterval) 
        },
        grabCursor: Number(this.dataset.slidesCount) > 1,
        loop: Number(this.dataset.slidesCount) > 1,
        slidesPerView: 1,
        breakpoints: {
          750: {
            autoplay: this.dataset.autoplay == "true" ? { delay: Number(this.dataset.autoplayInterval) } : false,
            enabled: !disabledDesktop || true,
          },
        },
      });

      if (disabledMobile && disabledDesktop) {
        swiper.disable();
      } else if (!disabledMobile && disabledDesktop) {
        if (window.innerWidth >= 750) {
          swiper.disable();
        }
      } else if (disabledMobile && !disabledDesktop) {
        if (window.innerWidth < 750) {
          swiper.disable();
        }
      }
  
      window.addEventListener("resize", () => {
        if (disabledMobile && disabledDesktop) {
          swiper.disable();
        } else if (!disabledMobile && disabledDesktop) {
          if (window.innerWidth >= 750) {
            swiper.disable();
          } else {
            swiper.enable();
          }
        } else if (disabledMobile && !disabledDesktop) {
          if (window.innerWidth < 750) {
            swiper.disable();
          } else {
            swiper.enable();
          }
        }
      });
    }
  }

  customElements.define("announcement-slider", AnnouncementSlider);
})();
